import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { ApiGetDataStatus, DealerPriceStateType } from '@redux/types'
import { DealerType, DealerPriceSheetRowType, DealerPriceSaveType } from '@schemas'

const initialState: DealerPriceStateType = {
	dealerList: [],
	dealerListStatus: 'init',
	selectedCustomerId: '',
	sheetDealer: null,
	sheetRows: [],
	sheetStatus: 'init',
	isSaving: false,
	savedCount: 0,
	triggerInit: false,
	save: null,
}

/** 납품가 관리 — 슬라이스는 persist 대상이 아니다(항상 서버에서 다시 읽는다) */
const slice = createSlice({
	name: 'dealerPrice',
	initialState,
	reducers: {
		TRIGGER_INIT_DEALER_PRICE_PAGE: (
			state: DealerPriceStateType,
			action: PayloadAction<boolean>,
		) => {
			state.triggerInit = action.payload
		},
		DEALER_LIST: (state: DealerPriceStateType, action: PayloadAction<DealerType[]>) => {
			state.dealerList = action.payload
		},
		DEALER_LIST_STATUS: (
			state: DealerPriceStateType,
			action: PayloadAction<ApiGetDataStatus>,
		) => {
			state.dealerListStatus = action.payload
		},
		SELECT_DEALER: (state: DealerPriceStateType, action: PayloadAction<string>) => {
			state.selectedCustomerId = action.payload
		},
		SHEET: (
			state: DealerPriceStateType,
			action: PayloadAction<{
				dealer: DealerType | null
				rows: DealerPriceSheetRowType[]
			}>,
		) => {
			state.sheetDealer = action.payload.dealer
			state.sheetRows = action.payload.rows
		},
		SHEET_STATUS: (
			state: DealerPriceStateType,
			action: PayloadAction<ApiGetDataStatus>,
		) => {
			state.sheetStatus = action.payload
		},
		SAVE_DEALER_PRICE: (
			state: DealerPriceStateType,
			action: PayloadAction<{ customerId: string; body: DealerPriceSaveType }>,
		) => {
			state.save = action.payload
		},
		IS_SAVING: (state: DealerPriceStateType, action: PayloadAction<boolean>) => {
			state.isSaving = action.payload
		},
		SAVED: (state: DealerPriceStateType) => {
			state.savedCount += 1
		},
	},
})

export const dealerPriceActions = slice.actions
export default slice.reducer
